import { default as waypointsReducer } from '@/store/reducers/edit_ride/waypoints';
import optionsReducer, {
    initialState as optionsInitialState
} from '@/store/reducers/edit_ride/options';
import { CHANGE_ROUTE } from '@/store/actions/edit_ride/routes';
import {
    UPDATE,
    BULK_UPDATE,
    LOAD,
    CLEAR_MAPS_FIELDS,
    DID_CALCULATE_ROUTE
} from '@/store/actions/edit_ride/ride';

// props that are not saved to the backend
export const mapsInitialState = {
    // Here maps routing applied to waypoints
    points: [],
    // Driving directions
    leg: [],
    distances: [],
    // ride summary
    summary: null,
    mode: null,
    routes: null,
    shape: [],
    traffic: [],
    _lastWaypointAction: 0
};

export const initialState = {
    // Name of the ride
    name: '',
    // Description of ride
    description: '',
    // Route distance
    length: 0,
    // Route time
    duration: 0,
    // User-defined waypoints
    waypoints: [],
    dealerId: null,
    eventId: null,
    event: null,
    // Default ride data (required by backend)
    difficulty: 'NEW_TO_RIDING',
    style: 'CRUISER',
    privacy: 'PRIVATE',
    type: 'CUSTOM',
    rideAvoidances: optionsInitialState,
    ...mapsInitialState
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE: {
            const { field, value } = action.data;
            return { ...state, [field]: value };
        }

        case BULK_UPDATE: {
            return { ...state, ...action.data };
        }

        case LOAD: {
            const { ride: loadRide } = action.data;
            const rideAvoidances = {
                ...initialState.rideAvoidances,
                ...(loadRide.rideAvoidances || {})
            };
            return { ...initialState, ...loadRide, rideAvoidances };
        }

        case CLEAR_MAPS_FIELDS: {
            return { ...state, ...mapsInitialState };
        }

        case CHANGE_ROUTE:
        case DID_CALCULATE_ROUTE: {
            const { ride } = action.data;
            return {
                ...state,
                ...mapsInitialState,
                ...ride,
                length:
                    typeof ride !== 'undefined' &&
                    typeof ride.length !== 'undefined'
                        ? ride.length
                        : state.length,
                duration:
                    typeof ride !== 'undefined' &&
                    typeof ride.duration !== 'undefined'
                        ? ride.duration
                        : state.duration
            };
        }

        default: {
            const time = action.time || state._lastWaypointAction;

            return {
                ...state,
                rideAvoidances: optionsReducer(state.rideAvoidances, action),
                waypoints:
                    time >= state._lastWaypointAction
                        ? waypointsReducer(state.waypoints, action)
                        : state.waypoints,
                _lastWaypointAction: time
            };
        }
    }
};
